/**
 * Legacy alias: all marketing pages should use the same nav as SharedLayout.
 */
import React from 'react'
import { Navbar } from './SharedLayout'

const Header: React.FC = () => <Navbar />

export default Header
